var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgList = function SvgList(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23 0H5C3.346 0 2 1.346 2 3v22c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V3c0-1.654-1.346-3-3-3m1 25a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3c0-.551.449-1 1-1h18c.551 0 1 .449 1 1zM9 6H8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m10 0h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2M9 11H8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m10 0h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2M9 16H8a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m10 0h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"
  })));
};
export default SvgList;